import { createFileRoute } from "@tanstack/react-router"

import { breadcrumbJsonLd, buildHead } from "@/core/seo"

import { ProductPage } from "../../components/landing"
import { RECEIPT_SCANNER_ZH, RECEIPT_SEO_ZH } from "../../content/zh/products/receipt-scanner"

/** Chinese version of /receipt-scanner (D-WEB-LANG-SCOPE); the English route carries the hreflang pair too. */
export const receiptScannerZhSeo = () =>
  buildHead({
    ...RECEIPT_SEO_ZH,
    path: RECEIPT_SCANNER_ZH.path,
    localePrefix: "zh",
    jsonLd: [breadcrumbJsonLd([{ name: "首页", path: "/zh" }, { name: RECEIPT_SCANNER_ZH.name }])],
  })

export const Route = createFileRoute("/_brand-layout/zh/receipt-scanner")({
  head: () => {
    const { meta, links, scripts } = receiptScannerZhSeo()
    return { meta, links, scripts }
  },
  component: ReceiptScannerZhPage,
})

export function ReceiptScannerZhPage() {
  return <ProductPage content={RECEIPT_SCANNER_ZH} />
}
